export interface ShopProduct {
  id: string;
  name: string;
  nameEn: string;
  category: 'clothes' | 'pants' | 'infant' | 'hat' | 'book' | 'pencil' | 'gift' | 'notebook';
  categoryLabel: string;
  price: number;
  originalPrice?: number;
  currency: string;
  image: string;
  warehouse: string;
  warehouseFlag: string;
  warehouseCity: string;
  badge?: string;
  rating: number;
  sold: number;
  commission?: string;
}

export const shopProducts: ShopProduct[] = [
  {
    id: 'p001',
    name: '优雅真丝衬衫',
    nameEn: 'Silk Blouse',
    category: 'clothes',
    categoryLabel: '女装',
    price: 128,
    originalPrice: 198,
    currency: '¥',
    image: 'https://public.readdy.ai/ai/img_res/5869fe4d9b7066565b5d883382f3603e.jpg',
    warehouse: '🇨🇳',
    warehouseFlag: '🇨🇳',
    warehouseCity: '上海仓',
    badge: '热销',
    rating: 4.9,
    sold: 2341,
    commission: '12%',
  },
  {
    id: 'p002',
    name: '修身休闲长裤',
    nameEn: 'Slim Casual Pants',
    category: 'pants',
    categoryLabel: '裤装',
    price: 89,
    originalPrice: 139,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20slim%20fit%20tailored%20casual%20trousers%2C%20deep%20midnight%20navy%20blue%2C%20perfect%20crease%2C%20premium%20wool%20blend%20fabric%2C%20elegant%20fashion%20product%20photography%2C%20pure%20white%20background%2C%20luxury%20menswear%20quality%2C%20sharp%20clean%20lines&width=400&height=400&seq=cloth_new_02&orientation=squarish',
    warehouse: '🇨🇳',
    warehouseFlag: '🇨🇳',
    warehouseCity: '北京仓',
    rating: 4.8,
    sold: 1876,
    commission: '10%',
  },
  {
    id: 'p003',
    name: '婴儿连体衣套装',
    nameEn: 'Baby Romper Set',
    category: 'infant',
    categoryLabel: '婴儿服',
    price: 59,
    originalPrice: 89,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=adorable%20premium%20baby%20romper%20onesie%20set%2C%20ultra%20soft%20organic%20cotton%2C%20beautiful%20pastel%20blush%20pink%20and%20cream%20colors%2C%20delicate%20embroidery%20details%2C%20elegant%20gift%20presentation%2C%20pure%20white%20background%2C%20luxury%20infant%20fashion%20photography&width=400&height=400&seq=cloth_new_03&orientation=squarish',
    warehouse: '🇭🇰',
    warehouseFlag: '🇭🇰',
    warehouseCity: '香港仓',
    badge: '新品',
    rating: 4.9,
    sold: 987,
    commission: '8%',
  },
  {
    id: 'p004',
    name: '经典棒球帽',
    nameEn: 'Classic Baseball Cap',
    category: 'hat',
    categoryLabel: '帽子',
    price: 45,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20premium%20classic%20baseball%20cap%2C%20warm%20ivory%20cream%20color%2C%20fine%20cotton%20twill%20fabric%2C%20perfectly%20structured%20brim%2C%20elegant%20minimal%20embroidery%20logo%2C%20luxury%20fashion%20accessory%20photography%2C%20pure%20white%20background%2C%20high-end%20streetwear%20style&width=400&height=400&seq=cloth_new_04&orientation=squarish',
    warehouse: '🇸🇬',
    warehouseFlag: '🇸🇬',
    warehouseCity: '新加坡仓',
    rating: 4.7,
    sold: 3210,
  },
  {
    id: 'p005',
    name: '《幸福婚姻指南》',
    nameEn: 'Happy Marriage Guide',
    category: 'book',
    categoryLabel: '书籍',
    price: 38,
    originalPrice: 58,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20hardcover%20book%20about%20marriage%20and%20relationships%2C%20warm%20golden%20cover%20design%2C%20elegant%20typography%2C%20clean%20white%20background%2C%20product%20photography%2C%20inspirational%20book&width=400&height=400&seq=shop005&orientation=squarish',
    warehouse: '🇦🇺',
    warehouseFlag: '🇦🇺',
    warehouseCity: '悉尼仓',
    badge: '畅销',
    rating: 4.9,
    sold: 5432,
    commission: '15%',
  },
  {
    id: 'p006',
    name: '彩色铅笔礼盒装',
    nameEn: 'Colored Pencil Gift Set',
    category: 'pencil',
    categoryLabel: '文具',
    price: 29,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=colorful%20pencil%20set%20in%20gift%20box%2C%2024%20colors%2C%20rainbow%20arrangement%2C%20clean%20white%20background%2C%20product%20photography%2C%20premium%20quality%20art%20supplies%2C%20beautiful%20packaging&width=400&height=400&seq=shop006&orientation=squarish',
    warehouse: '🇦🇪',
    warehouseFlag: '🇦🇪',
    warehouseCity: '迪拜仓',
    rating: 4.8,
    sold: 2109,
    commission: '18%',
  },
  {
    id: 'p007',
    name: '儿童防晒帽',
    nameEn: 'Kids Sun Hat',
    category: 'hat',
    categoryLabel: '帽子',
    price: 35,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20cute%20kids%20wide%20brim%20sun%20hat%2C%20soft%20sky%20blue%20cotton%2C%20adorable%20bow%20detail%2C%20UV%20protection%20summer%20hat%20for%20children%2C%20elegant%20product%20photography%2C%20pure%20white%20background%2C%20premium%20quality%20children%20accessory&width=400&height=400&seq=cloth_new_07&orientation=squarish',
    warehouse: '🇬🇧',
    warehouseFlag: '🇬🇧',
    warehouseCity: '伦敦仓',
    rating: 4.7,
    sold: 1543,
  },
  {
    id: 'p008',
    name: '婴儿保暖套装',
    nameEn: 'Baby Warm Set',
    category: 'infant',
    categoryLabel: '婴儿服',
    price: 79,
    originalPrice: 119,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20soft%20premium%20baby%20warm%20clothing%20set%2C%20luxurious%20fleece%20material%2C%20elegant%20light%20dove%20gray%20with%20cream%20trim%2C%20adorable%20newborn%20winter%20outfit%2C%20pure%20white%20background%2C%20high-end%20infant%20fashion%20photography%2C%20cozy%20and%20stylish&width=400&height=400&seq=cloth_new_08&orientation=squarish',
    warehouse: '🇺🇸',
    warehouseFlag: '🇺🇸',
    warehouseCity: '纽约仓',
    badge: '新品',
    rating: 4.8,
    sold: 876,
    commission: '9%',
  },
  {
    id: 'p009',
    name: '法式碎花连衣裙',
    nameEn: 'French Floral Dress',
    category: 'clothes',
    categoryLabel: '女装',
    price: 158,
    originalPrice: 228,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=stunning%20French%20style%20floral%20midi%20dress%2C%20gorgeous%20soft%20blush%20pink%20and%20white%20flower%20pattern%2C%20flowing%20chiffon%20fabric%20with%20elegant%20silhouette%2C%20beautiful%20fashion%20editorial%20photography%2C%20pure%20white%20background%2C%20luxury%20womenswear%2C%20romantic%20feminine%20couture&width=400&height=400&seq=cloth_new_09&orientation=squarish',
    warehouse: '🇨🇳',
    warehouseFlag: '🇨🇳',
    warehouseCity: '上海仓',
    badge: '热销',
    rating: 4.9,
    sold: 3120,
    commission: '13%',
  },
  {
    id: 'p010',
    name: '气质V领雪纺裙',
    nameEn: 'V-Neck Chiffon Dress',
    category: 'clothes',
    categoryLabel: '女装',
    price: 138,
    originalPrice: 199,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=breathtaking%20elegant%20V-neck%20chiffon%20dress%2C%20beautiful%20powder%20blue%20color%2C%20ultra%20flowing%20skirt%20with%20graceful%20movement%2C%20delicate%20fabric%20texture%2C%20luxury%20fashion%20editorial%20photography%2C%20pure%20white%20background%2C%20sophisticated%20feminine%20style%2C%20high-end%20womenswear&width=400&height=400&seq=cloth_new_10&orientation=squarish',
    warehouse: '🇨🇳',
    warehouseFlag: '🇨🇳',
    warehouseCity: '北京仓',
    rating: 4.8,
    sold: 2087,
    commission: '11%',
  },
  {
    id: 'p011',
    name: '复古格纹A字裙',
    nameEn: 'Vintage Plaid A-Line Dress',
    category: 'clothes',
    categoryLabel: '女装',
    price: 118,
    originalPrice: 168,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=gorgeous%20vintage%20plaid%20A-line%20dress%2C%20classic%20rich%20red%20and%20black%20tartan%20pattern%2C%20perfect%20knee%20length%20flare%20skirt%2C%20premium%20wool%20fabric%2C%20stunning%20fashion%20product%20photography%2C%20pure%20white%20background%2C%20chic%20retro%20British%20style%2C%20luxury%20womenswear&width=400&height=400&seq=cloth_new_11&orientation=squarish',
    warehouse: '🇬🇧',
    warehouseFlag: '🇬🇧',
    warehouseCity: '伦敦仓',
    badge: '精选',
    rating: 4.7,
    sold: 1654,
  },
  {
    id: 'p012',
    name: '优雅晚宴长裙',
    nameEn: 'Elegant Evening Gown',
    category: 'clothes',
    categoryLabel: '女装',
    price: 368,
    originalPrice: 520,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=breathtaking%20luxury%20evening%20gown%20dress%2C%20deep%20rich%20burgundy%20wine%20red%2C%20floor%20length%20with%20elegant%20train%2C%20lustrous%20satin%20fabric%2C%20exquisite%20beading%20detail%2C%20high-end%20couture%20fashion%20photography%2C%20pure%20white%20background%2C%20glamorous%20red%20carpet%20style&width=400&height=400&seq=cloth_new_12&orientation=squarish',
    warehouse: '🇫🇷',
    warehouseFlag: '🇫🇷',
    warehouseCity: '巴黎仓',
    badge: '限量',
    rating: 4.9,
    sold: 432,
    commission: '15%',
  },
  {
    id: 'p013',
    name: '清新棉麻连衣裙',
    nameEn: 'Cotton Linen Casual Dress',
    category: 'clothes',
    categoryLabel: '女装',
    price: 98,
    originalPrice: 148,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20casual%20cotton%20linen%20dress%2C%20warm%20natural%20oat%20beige%20color%2C%20relaxed%20elegant%20silhouette%2C%20fine%20linen%20texture%2C%20stylish%20summer%20fashion%20photography%2C%20pure%20white%20background%2C%20effortlessly%20chic%20everyday%20wear%2C%20premium%20quality%20fabric&width=400&height=400&seq=cloth_new_13&orientation=squarish',
    warehouse: '🇨🇳',
    warehouseFlag: '🇨🇳',
    warehouseCity: '上海仓',
    rating: 4.8,
    sold: 2890,
    commission: '10%',
  },
  {
    id: 'p014',
    name: '韩版蕾丝连衣裙',
    nameEn: 'Korean Lace Dress',
    category: 'clothes',
    categoryLabel: '女装',
    price: 148,
    originalPrice: 210,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=stunning%20Korean%20style%20lace%20dress%2C%20pristine%20white%20intricate%20floral%20lace%20fabric%2C%20beautiful%20feminine%20silhouette%2C%20delicate%20embroidery%20details%2C%20luxury%20fashion%20editorial%20photography%2C%20pure%20white%20background%2C%20sweet%20romantic%20elegant%20style%2C%20premium%20womenswear&width=400&height=400&seq=cloth_new_14&orientation=squarish',
    warehouse: '🇸🇬',
    warehouseFlag: '🇸🇬',
    warehouseCity: '新加坡仓',
    badge: '新品',
    rating: 4.8,
    sold: 1230,
    commission: '12%',
  },
  {
    id: 'p015',
    name: '职场OL包臀裙',
    nameEn: 'Office Bodycon Dress',
    category: 'clothes',
    categoryLabel: '女装',
    price: 168,
    originalPrice: 238,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=gorgeous%20professional%20office%20bodycon%20pencil%20dress%2C%20deep%20navy%20blue%2C%20perfectly%20tailored%20knee%20length%2C%20premium%20stretch%20fabric%20with%20elegant%20sheen%2C%20sophisticated%20business%20fashion%20photography%2C%20pure%20white%20background%2C%20powerful%20chic%20executive%20style&width=400&height=400&seq=cloth_new_15&orientation=squarish',
    warehouse: '🇭🇰',
    warehouseFlag: '🇭🇰',
    warehouseCity: '香港仓',
    rating: 4.7,
    sold: 1876,
  },
  {
    id: 'p016',
    name: '婴儿有机棉爬服',
    nameEn: 'Organic Cotton Baby Crawler',
    category: 'infant',
    categoryLabel: '婴儿服',
    price: 49,
    originalPrice: 75,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20premium%20organic%20cotton%20baby%20crawler%20romper%2C%20soft%20sage%20mint%20green%2C%20adorable%20tiny%20snap%20buttons%2C%20delicate%20embroidered%20bunny%20detail%2C%20luxury%20infant%20fashion%20photography%2C%20pure%20white%20background%2C%20ultra%20soft%20newborn%20clothing&width=400&height=400&seq=cloth_new_16&orientation=squarish',
    warehouse: '🇨🇳',
    warehouseFlag: '🇨🇳',
    warehouseCity: '上海仓',
    badge: '有机棉',
    rating: 4.9,
    sold: 3421,
    commission: '8%',
  },
  {
    id: 'p017',
    name: '宝宝四季睡衣套装',
    nameEn: 'Baby Pajama Set',
    category: 'infant',
    categoryLabel: '婴儿服',
    price: 65,
    originalPrice: 98,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=adorable%20beautiful%20baby%20pajama%20set%2C%20soft%20cotton%20with%20cute%20golden%20star%20pattern%20on%20pale%20yellow%2C%20sweet%20infant%20sleepwear%2C%20premium%20quality%20fabric%2C%20elegant%20product%20photography%2C%20pure%20white%20background%2C%20cozy%20luxury%20baby%20clothes&width=400&height=400&seq=cloth_new_17&orientation=squarish',
    warehouse: '🇭🇰',
    warehouseFlag: '🇭🇰',
    warehouseCity: '香港仓',
    rating: 4.8,
    sold: 2109,
  },
  {
    id: 'p018',
    name: '婴儿针织毛衣套装',
    nameEn: 'Baby Knit Sweater Set',
    category: 'infant',
    categoryLabel: '婴儿服',
    price: 88,
    originalPrice: 128,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=gorgeous%20baby%20knit%20sweater%20and%20pants%20set%2C%20ultra%20soft%20merino%20wool%20blend%2C%20beautiful%20blush%20rose%20pink%2C%20fine%20cable%20knit%20texture%2C%20adorable%20bow%20detail%2C%20luxury%20infant%20fashion%20photography%2C%20pure%20white%20background%2C%20premium%20baby%20winter%20outfit&width=400&height=400&seq=cloth_new_18&orientation=squarish',
    warehouse: '🇨🇳',
    warehouseFlag: '🇨🇳',
    warehouseCity: '北京仓',
    badge: '热销',
    rating: 4.9,
    sold: 1876,
    commission: '9%',
  },
  {
    id: 'p019',
    name: '宝宝卡通印花T恤',
    nameEn: 'Baby Cartoon Print Tee',
    category: 'infant',
    categoryLabel: '婴儿服',
    price: 35,
    originalPrice: 55,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20cute%20baby%20cartoon%20print%20t-shirt%2C%20premium%20soft%20cotton%2C%20vibrant%20colorful%20adorable%20animal%20illustration%20print%2C%20toddler%20fashion%20photography%2C%20pure%20white%20background%2C%20fun%20cheerful%20kids%20clothing%2C%20high%20quality%20fabric&width=400&height=400&seq=cloth_new_19&orientation=squarish',
    warehouse: '🇺🇸',
    warehouseFlag: '🇺🇸',
    warehouseCity: '纽约仓',
    rating: 4.7,
    sold: 2543,
  },
  {
    id: 'p020',
    name: '婴儿礼盒全套装',
    nameEn: 'Baby Gift Box Full Set',
    category: 'infant',
    categoryLabel: '婴儿服',
    price: 168,
    originalPrice: 238,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=stunning%20complete%20luxury%20baby%20gift%20box%20set%2C%20beautiful%20pastel%20collection%20with%20romper%20hat%20socks%20and%20bib%2C%20exquisite%20ribbon%20packaging%2C%20elegant%20newborn%20shower%20gift%2C%20pure%20white%20background%2C%20premium%20product%20photography%2C%20gorgeous%20presentation&width=400&height=400&seq=cloth_new_20&orientation=squarish',
    warehouse: '🇭🇰',
    warehouseFlag: '🇭🇰',
    warehouseCity: '香港仓',
    badge: '礼盒装',
    rating: 4.9,
    sold: 1234,
    commission: '10%',
  },
  {
    id: 'p021',
    name: '宝宝防风连帽外套',
    nameEn: 'Baby Hooded Windbreaker',
    category: 'infant',
    categoryLabel: '婴儿服',
    price: 95,
    originalPrice: 138,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20premium%20baby%20hooded%20windbreaker%20jacket%2C%20gorgeous%20sky%20blue%20with%20white%20lining%2C%20adorable%20bear%20ear%20hood%20detail%2C%20soft%20inner%20fleece%2C%20luxury%20toddler%20outerwear%20photography%2C%20pure%20white%20background%2C%20stylish%20infant%20coat&width=400&height=400&seq=cloth_new_21&orientation=squarish',
    warehouse: '🇸🇬',
    warehouseFlag: '🇸🇬',
    warehouseCity: '新加坡仓',
    rating: 4.8,
    sold: 987,
  },
  {
    id: 'p022',
    name: '精美香薰礼盒套装',
    nameEn: 'Aromatherapy Gift Set',
    category: 'gift',
    categoryLabel: '礼品',
    price: 128,
    originalPrice: 188,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=luxury%20aromatherapy%20gift%20set%20with%20candles%20and%20essential%20oils%2C%20elegant%20white%20and%20gold%20packaging%2C%20clean%20white%20background%2C%20product%20photography%2C%20premium%20gift%20box&width=400&height=400&seq=shop022&orientation=squarish',
    warehouse: '🇫🇷',
    warehouseFlag: '🇫🇷',
    warehouseCity: '巴黎仓',
    badge: '热销',
    rating: 4.9,
    sold: 2876,
    commission: '14%',
  },
  {
    id: 'p023',
    name: '手工巧克力礼盒',
    nameEn: 'Handmade Chocolate Gift Box',
    category: 'gift',
    categoryLabel: '礼品',
    price: 88,
    originalPrice: 128,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=luxury%20handmade%20chocolate%20gift%20box%2C%20assorted%20pralines%2C%20elegant%20dark%20packaging%20with%20gold%20ribbon%2C%20clean%20white%20background%2C%20product%20photography%2C%20premium%20confectionery&width=400&height=400&seq=shop023&orientation=squarish',
    warehouse: '🇬🇧',
    warehouseFlag: '🇬🇧',
    warehouseCity: '伦敦仓',
    badge: '精选',
    rating: 4.8,
    sold: 3210,
  },
  {
    id: 'p024',
    name: '定制水晶相框',
    nameEn: 'Custom Crystal Photo Frame',
    category: 'gift',
    categoryLabel: '礼品',
    price: 68,
    originalPrice: 98,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=elegant%20crystal%20glass%20photo%20frame%2C%20clear%20transparent%20with%20silver%20edge%2C%20romantic%20gift%2C%20clean%20white%20background%2C%20product%20photography%2C%20premium%20home%20decor&width=400&height=400&seq=shop024&orientation=squarish',
    warehouse: '🇨🇳',
    warehouseFlag: '🇨🇳',
    warehouseCity: '上海仓',
    rating: 4.7,
    sold: 1543,
    commission: '12%',
  },
  {
    id: 'p025',
    name: '高档茶叶礼盒',
    nameEn: 'Premium Tea Gift Box',
    category: 'gift',
    categoryLabel: '礼品',
    price: 198,
    originalPrice: 280,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=premium%20Chinese%20tea%20gift%20box%20set%2C%20elegant%20wooden%20box%20with%20assorted%20teas%2C%20gold%20and%20red%20packaging%2C%20clean%20white%20background%2C%20product%20photography%2C%20luxury%20tea%20collection&width=400&height=400&seq=shop025&orientation=squarish',
    warehouse: '🇨🇳',
    warehouseFlag: '🇨🇳',
    warehouseCity: '北京仓',
    badge: '畅销',
    rating: 4.9,
    sold: 4321,
    commission: '16%',
  },
  {
    id: 'p026',
    name: '丝巾礼盒套装',
    nameEn: 'Silk Scarf Gift Set',
    category: 'gift',
    categoryLabel: '礼品',
    price: 158,
    originalPrice: 228,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=luxury%20silk%20scarf%20gift%20set%2C%20colorful%20floral%20pattern%2C%20elegant%20gift%20box%20packaging%2C%20clean%20white%20background%2C%20product%20photography%2C%20premium%20fashion%20accessory%20gift&width=400&height=400&seq=shop026&orientation=squarish',
    warehouse: '🇭🇰',
    warehouseFlag: '🇭🇰',
    warehouseCity: '香港仓',
    badge: '新品',
    rating: 4.8,
    sold: 876,
  },
  {
    id: 'p027',
    name: '精美首饰礼盒',
    nameEn: 'Jewelry Gift Box',
    category: 'gift',
    categoryLabel: '礼品',
    price: 238,
    originalPrice: 338,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=elegant%20jewelry%20gift%20box%20with%20necklace%20and%20earrings%20set%2C%20rose%20gold%20color%2C%20velvet%20box%2C%20clean%20white%20background%2C%20product%20photography%2C%20luxury%20romantic%20gift&width=400&height=400&seq=shop027&orientation=squarish',
    warehouse: '🇦🇪',
    warehouseFlag: '🇦🇪',
    warehouseCity: '迪拜仓',
    badge: '限量',
    rating: 4.9,
    sold: 654,
    commission: '18%',
  },
  {
    id: 'p028',
    name: '婚庆伴手礼套装',
    nameEn: 'Wedding Favor Gift Set',
    category: 'gift',
    categoryLabel: '礼品',
    price: 48,
    originalPrice: 68,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=elegant%20wedding%20favor%20gift%20set%2C%20small%20decorative%20box%20with%20ribbon%2C%20red%20and%20gold%20colors%2C%20Chinese%20wedding%20style%2C%20clean%20white%20background%2C%20product%20photography&width=400&height=400&seq=shop028&orientation=squarish',
    warehouse: '🇨🇳',
    warehouseFlag: '🇨🇳',
    warehouseCity: '上海仓',
    rating: 4.8,
    sold: 5678,
    commission: '10%',
  },
  {
    id: 'p029',
    name: 'A5皮面精装笔记本',
    nameEn: 'A5 Leather Hardcover Notebook',
    category: 'notebook',
    categoryLabel: '笔记本',
    price: 58,
    originalPrice: 88,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=premium%20A5%20leather%20hardcover%20notebook%2C%20dark%20brown%20genuine%20leather%20cover%2C%20gold%20embossed%20design%2C%20clean%20white%20background%2C%20product%20photography%2C%20elegant%20stationery&width=400&height=400&seq=shop029&orientation=squarish',
    warehouse: '🇨🇳',
    warehouseFlag: '🇨🇳',
    warehouseCity: '上海仓',
    badge: '热销',
    rating: 4.9,
    sold: 4321,
    commission: '15%',
  },
  {
    id: 'p030',
    name: '手账本套装礼盒',
    nameEn: 'Journal Planner Gift Set',
    category: 'notebook',
    categoryLabel: '笔记本',
    price: 98,
    originalPrice: 148,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20journal%20planner%20gift%20set%20with%20stickers%20and%20pens%2C%20pastel%20pink%20cover%2C%20cute%20stationery%20set%2C%20clean%20white%20background%2C%20product%20photography%2C%20kawaii%20style%20notebook&width=400&height=400&seq=shop030&orientation=squarish',
    warehouse: '🇯🇵',
    warehouseFlag: '🇯🇵',
    warehouseCity: '东京仓',
    badge: '礼盒装',
    rating: 4.9,
    sold: 3210,
    commission: '17%',
  },
  {
    id: 'p031',
    name: '复古牛皮旅行日记本',
    nameEn: 'Vintage Leather Travel Journal',
    category: 'notebook',
    categoryLabel: '笔记本',
    price: 78,
    originalPrice: 118,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=vintage%20genuine%20leather%20travel%20journal%20notebook%2C%20distressed%20brown%20leather%2C%20handmade%20stitching%2C%20clean%20white%20background%2C%20product%20photography%2C%20rustic%20style%20diary&width=400&height=400&seq=shop031&orientation=squarish',
    warehouse: '🇬🇧',
    warehouseFlag: '🇬🇧',
    warehouseCity: '伦敦仓',
    rating: 4.8,
    sold: 1876,
    commission: '13%',
  },
  {
    id: 'p032',
    name: '方格子弹笔记本',
    nameEn: 'Dotted Bullet Journal',
    category: 'notebook',
    categoryLabel: '笔记本',
    price: 45,
    originalPrice: 68,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=dotted%20bullet%20journal%20notebook%2C%20minimalist%20black%20cover%2C%20A5%20size%2C%20premium%20paper%2C%20clean%20white%20background%2C%20product%20photography%2C%20modern%20stationery&width=400&height=400&seq=shop032&orientation=squarish',
    warehouse: '🇩🇪',
    warehouseFlag: '🇩🇪',
    warehouseCity: '柏林仓',
    badge: '精选',
    rating: 4.8,
    sold: 2543,
  },
  {
    id: 'p033',
    name: '水彩插画笔记本',
    nameEn: 'Watercolor Illustration Notebook',
    category: 'notebook',
    categoryLabel: '笔记本',
    price: 38,
    originalPrice: 58,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20watercolor%20illustration%20notebook%2C%20floral%20cover%20design%2C%20soft%20pastel%20colors%2C%20A5%20size%2C%20clean%20white%20background%2C%20product%20photography%2C%20artistic%20stationery&width=400&height=400&seq=shop033&orientation=squarish',
    warehouse: '🇨🇳',
    warehouseFlag: '🇨🇳',
    warehouseCity: '上海仓',
    rating: 4.7,
    sold: 3109,
    commission: '14%',
  },
  {
    id: 'p034',
    name: '商务精装记事本套装',
    nameEn: 'Business Hardcover Planner Set',
    category: 'notebook',
    categoryLabel: '笔记本',
    price: 128,
    originalPrice: 188,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=premium%20business%20hardcover%20planner%20notebook%20set%20with%20pen%2C%20dark%20navy%20blue%20cover%2C%20gold%20logo%2C%20clean%20white%20background%2C%20product%20photography%2C%20professional%20executive%20stationery&width=400&height=400&seq=shop034&orientation=squarish',
    warehouse: '🇸🇬',
    warehouseFlag: '🇸🇬',
    warehouseCity: '新加坡仓',
    badge: '新品',
    rating: 4.9,
    sold: 1432,
    commission: '16%',
  },
  {
    id: 'p035',
    name: '儿童涂鸦绘画本',
    nameEn: 'Kids Drawing Sketchbook',
    category: 'notebook',
    categoryLabel: '笔记本',
    price: 28,
    originalPrice: 42,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=colorful%20kids%20drawing%20sketchbook%2C%20thick%20pages%2C%20rainbow%20cover%20design%2C%20children%20art%20supplies%2C%20clean%20white%20background%2C%20product%20photography%2C%20fun%20stationery%20for%20kids&width=400&height=400&seq=shop035&orientation=squarish',
    warehouse: '🇨🇳',
    warehouseFlag: '🇨🇳',
    warehouseCity: '北京仓',
    rating: 4.8,
    sold: 4567,
    commission: '12%',
  },
  {
    id: 'p036',
    name: '婚礼纪念相册本',
    nameEn: 'Wedding Memory Album',
    category: 'notebook',
    categoryLabel: '笔记本',
    price: 88,
    originalPrice: 128,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=elegant%20wedding%20memory%20photo%20album%2C%20white%20lace%20cover%20with%20gold%20lettering%2C%20romantic%20design%2C%20clean%20white%20background%2C%20product%20photography%2C%20premium%20keepsake%20album&width=400&height=400&seq=shop036&orientation=squarish',
    warehouse: '🇭🇰',
    warehouseFlag: '🇭🇰',
    warehouseCity: '香港仓',
    badge: '畅销',
    rating: 4.9,
    sold: 2109,
  },
  {
    id: 'p037',
    name: '宝宝成长记录本',
    nameEn: 'Baby Growth Memory Book',
    category: 'notebook',
    categoryLabel: '笔记本',
    price: 68,
    originalPrice: 98,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=cute%20baby%20growth%20memory%20book%20journal%2C%20soft%20pastel%20blue%20cover%20with%20baby%20illustrations%2C%20milestone%20record%20book%2C%20clean%20white%20background%2C%20product%20photography%2C%20newborn%20keepsake&width=400&height=400&seq=shop037&orientation=squarish',
    warehouse: '🇦🇺',
    warehouseFlag: '🇦🇺',
    warehouseCity: '悉尼仓',
    badge: '新品',
    rating: 4.9,
    sold: 1654,
    commission: '11%',
  },
  {
    id: 'p038',
    name: '婴儿棉纱浴巾套装',
    nameEn: 'Baby Muslin Towel Set',
    category: 'infant',
    categoryLabel: '婴儿服',
    price: 55,
    originalPrice: 80,
    currency: '¥',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20premium%20baby%20muslin%20cotton%20towel%20set%2C%20pristine%20white%20and%20soft%20cream%2C%20ultra%20gentle%20gauze%20fabric%2C%20adorable%20embroidered%20duck%20detail%2C%20luxury%20newborn%20bath%20set%2C%20pure%20white%20background%2C%20high-end%20infant%20care%20photography&width=400&height=400&seq=cloth_new_38&orientation=squarish',
    warehouse: '🇨🇳',
    warehouseFlag: '🇨🇳',
    warehouseCity: '上海仓',
    rating: 4.8,
    sold: 2876,
    commission: '8%',
  },
];

export const shopCategories = [
  { key: 'all', label: '全部', icon: 'ri-apps-line' },
  { key: 'clothes', label: '女装', icon: 'ri-t-shirt-line' },
  { key: 'pants', label: '裤装', icon: 'ri-t-shirt-2-line' },
  { key: 'infant', label: '婴儿服', icon: 'ri-heart-line' },
  { key: 'hat', label: '帽子', icon: 'ri-user-smile-line' },
  { key: 'gift', label: '礼品', icon: 'ri-gift-line' },
  { key: 'notebook', label: '笔记本', icon: 'ri-book-2-line' },
  { key: 'book', label: '书籍', icon: 'ri-book-open-line' },
  { key: 'pencil', label: '文具', icon: 'ri-pencil-line' },
];

export const warehouses = [
  { city: '上海', flag: '🇨🇳', label: '上海仓', region: '中国大陆' },
  { city: '北京', flag: '🇨🇳', label: '北京仓', region: '中国大陆' },
  { city: '香港', flag: '🇭🇰', label: '香港仓', region: '港澳台' },
  { city: '新加坡', flag: '🇸🇬', label: '新加坡仓', region: '亚太' },
  { city: '悉尼', flag: '🇦🇺', label: '悉尼仓', region: '亚太' },
  { city: '东京', flag: '🇯🇵', label: '东京仓', region: '亚太' },
  { city: '迪拜', flag: '🇦🇪', label: '迪拜仓', region: '中东' },
  { city: '伦敦', flag: '🇬🇧', label: '伦敦仓', region: '欧洲' },
  { city: '柏林', flag: '🇩🇪', label: '柏林仓', region: '欧洲' },
  { city: '巴黎', flag: '🇫🇷', label: '巴黎仓', region: '欧洲' },
  { city: '纽约', flag: '🇺🇸', label: '纽约仓', region: '北美' },
];
